import React from 'react';
import { JSXUnrendered } from './types';

/**
 * Returns whether the given React node is renderable by React or not.
 * @see https://reactjs.org/docs/jsx-in-depth.html#booleans-null-and-undefined-are-ignored
 * @param content The content that may or may not be renderable
 */
export const isUnrenderable = (content: React.ReactNode): content is JSXUnrendered =>
  typeof content === 'boolean' || content === null || typeof content === 'undefined';
